import { NameFormResult, QuoteInitialForm } from '@lib/data/typesQuestions';
import FormField from 'components/atoms/FormField';
import GridBox from 'components/atoms/GridBox';
import TextField from 'components/atoms/TextField';
import OnboardingButtonBar from 'components/molecules/button-bar/OnboardingButtonBar';
import { FC } from 'react';
import { useForm } from 'react-hook-form';
import styled from 'styled-components';

const Form = styled.form``;

interface FormResult {
  name: string;
}

interface Props {
  onSubmit: (data: NameFormResult) => void;
  loading: boolean;
  item: QuoteInitialForm;
}

const NameForm: FC<Props> = ({ onSubmit, loading, item }) => {
  const { register, handleSubmit, errors } = useForm<FormResult>();

  return (
    <Form
      onSubmit={handleSubmit((data) => {
        if (item.conductor)
          onSubmit({ conductor: { ...item.conductor, name: data.name } });
      })}
    >
      <GridBox justifyContent="center">
        <GridBox width={[1, 0.5, 0.5]}>
          <FormField style={{ width: '100%' }} >
            <TextField
              placeholder="Nome Completo"
              name="name"
              autoComplete="name"
              defaultValue={item.conductor?.name || ''}
              errorMessage={errors.name?.message}
              inputRef={register({
                required: 'Precisamos do seu completo',
                validate: {
                  fullName: (name: string) => {
                    const names = name.trim().split(' ');

                    const allNamesHas2Characters = names.every(
                      (str) => str.length >= 2,
                    );

                    const hasMoreThan2Names = names.length >= 2;

                    return (
                      (allNamesHas2Characters && hasMoreThan2Names) ||
                      'Precisamos do seu completo '
                    );
                  },
                },
              })}
            />
          </FormField>
        </GridBox>
      </GridBox>
      <OnboardingButtonBar loading={loading} />
    </Form>
  );
};

export default NameForm;
